import React from 'react';
import ModulePageFrame from '../../custom-modules/components/module-page-frame';

export default function OrganizeProductsPage() {
  return <ModulePageFrame page="organize-products" />;
}
